export default "__VITE_PUBLIC_ASSET__072665b6__"